export const TaskEndMarkerIcon = () => (
  <div
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 2,
      borderRadius: '9999px',
      backgroundColor: 'rgba(255,255,255,0.5)',
    }}
  >
    <div
      style={{
        width: 24,
        height: 24,
        borderRadius: '9999px',
        backgroundColor: '#d54242',
        boxShadow: '0px 0px 3.31px 3.31px rgba(0,0,0,0.05)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: 8,
          height: 8,
          borderRadius: '9999px',
          backgroundColor: '#ffffff',
          boxShadow: '0px 0px 3.31px 3.31px rgba(0,0,0,0.05)',
        }}
      />
    </div>
  </div>
)

export const TaskStartMarkerIcon = () => (
  <div
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 2,
      borderRadius: '9999px',
      border: '1px solid rgba(0,0,0,0.5)',
      backgroundColor: '#ffffff',
    }}
  >
    <div
      style={{
        width: 24,
        height: 24,
        borderRadius: '9999px',
        backgroundColor: '#000000',
        boxShadow: '0px 0px 3.31px 3.31px rgba(0,0,0,0.05)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: 8,
          height: 8,
          borderRadius: '9999px',
          backgroundColor: '#ffffff',
          boxShadow: '0px 0px 3.31px 3.31px rgba(0,0,0,0.05)',
        }}
      />
    </div>
  </div>
)

// `visited` toggles the fill: a visited stop is a solid black pin with a white number, an
// unvisited (still-to-reach) stop is a white pin with a black number.
export const TaskCheckpointMarkerIcon = ({
  counter,
  visited = true,
}: {
  counter: number
  visited?: boolean
}) => (
  <div
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 2,
      borderRadius: '9999px',
      border: '1px solid rgba(0,0,0,0.5)',
      backgroundColor: '#ffffff',
    }}
  >
    <div
      style={{
        width: 24,
        height: 24,
        borderRadius: '9999px',
        backgroundColor: visited ? '#000000' : '#ffffff',
        boxShadow: '0px 0px 3.31px 3.31px rgba(0,0,0,0.05)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <span
        style={{
          color: visited ? '#ffffff' : '#000000',
          fontSize: 10,
          fontWeight: 700,
          fontFamily: 'Inter, Helvetica, Arial, sans-serif',
          lineHeight: 1,
          pointerEvents: 'none',
        }}
      >
        {counter}
      </span>
    </div>
  </div>
)
